export class RoleAnagrafModel {
  id: number;
  code: string;
  description: string;
  checked: boolean;


  constructor(id?: number, cod?: string, description?: string) {
    this.id = id;
    this.code = cod;
    this.description = description;
  }
}
